import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input, Button, Modal, Row, Col, DatePicker, Collapse } from "antd";
import { DownOutlined } from "@ant-design/icons";
import _ from "lodash";
import "./index.scss";
import {
  GET_USER_AGGREGATE_INFO,
  GET_USER_INFO,
  UPDATE_USER_INFO,
} from "reducers/authReducer";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import UploadFileModal from "./UploadFileModal";
import { RootState } from "reducers/rootReducer";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import { ENCRYPT_TOKEN } from "reducers/authReducer";
import { popupCenter } from "utils/appUtil";

const LocationInput: React.FC<any> = ({
  value = undefined,
  placeholder,
  onChange,
}) => {
  return (
    <div className="datetime-item">
      <GooglePlacesAutocomplete
        selectProps={{
          value,
          onChange: (place: any) => {
            if (place?.value) {
              geocodeByPlaceId(place.value.place_id)
                .then((results) => {
                  if (results[0].geometry) {
                    let location = {
                      attributes: {
                        ...place,
                        address: place.label,
                      },
                      coordinates: {
                        lat: results[0].geometry.location.lat(),
                        long: results[0].geometry.location.lng(),
                      },
                    };
                    onChange(location);
                  }
                })
                .catch((error) => console.error(error));
            }
          },
          isClearable: false,
          placeholder: placeholder,
          styles: {
            input: (provided: any) => ({
              ...provided,
              fontFamily: "Nunito-Regular",
            }),
            control: () => ({
              backgroundColor: "transparent",
              display: "flex",
            }),
            container: (provided, state) => ({
              ...provided,
              width: "100%",
              background: "transparent",
            }),
            placeholder: (provided, state) => ({
              ...provided,
              color: "#000",
              fontSize: 16,
              padding: 8,
            }),
            singleValue: (provided, state) => ({
              ...provided,
              color: "#000",
              fontSize: 16,
              padding: 8,
            }),
          },
        }}
        apiKey={"AIzaSyDgNagv_ozKWc6IQ75Ol4cH8fxdntOaW6M"}
      />
    </div>
  );
};

const EditBioModal: FC<{ onClose: () => void }> = ({ onClose }) => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const [firstname, setFirstname] = useState<string>("");
  const [lastname, setLastname] = useState<string>("");
  const [gender, setGender] = useState<string>("Male");
  const [dob, setDOB] = useState<moment.Moment>(moment());
  const [address, setAddress] = useState<any>();
  const { userInfo } = useSelector((state: RootState) => state.auth);
  const [isUploadModalVisible, setIsUploadModalVisible] =
    useState<boolean>(false);
  const { fileToSend } = useSelector((state: RootState) => state.message);
  const { projects } = useSelector((state: RootState) => state.dashboard);
  const [imgData, setImgData] = useState(null);

  useEffect(() => {
    dispatch(GET_USER_AGGREGATE_INFO({ serviceId: localStorage.getItem("selectedOrg") || "cudb-live" }));
  }, []);

  useEffect(() => {
    if (userInfo) {
      setFirstname(userInfo.firstName);
      setLastname(userInfo.lastName);
      setAddress(userInfo.location);
      setGender(userInfo.gender || "Male");
      setDOB(userInfo.dob ? moment(userInfo.dob, "YYYY-MM-DD") : moment());
      setImgData(
        userInfo?.profileImage?.urls?.original?.url ?? "/images/scene.png"
      );
    }
    console.log("userInfo", userInfo);
  }, [userInfo]);

  useEffect(() => {
    if (fileToSend && fileToSend.isBio) {
      dispatch(
        UPDATE_USER_INFO({
          ...userInfo,
          profileImage: { urls: fileToSend.urls },
        })
      );
    }
  }, [fileToSend]);

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  const handleOk = () => {
    dispatch(
      UPDATE_USER_INFO({
        ...userInfo,
        firstName: firstname,
        lastName: lastname,
        location: address,
        gender,
        dob: moment(dob).format("YYYY-MM-DD"),
        serviceId: localStorage.getItem("selectedOrg") || "cudb-live"
      })
    );
    setIsModalVisible(false);
    onClose && onClose();
  };

  return (
    <Modal
      title="Edit Bio"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <Row className="text-center mb-5">
        <Col span={24}>
          <img
            src={imgData || "/images/scene.png"}
            className="profileImage cursor-pointer"
            onClick={() => setIsUploadModalVisible(true)}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Input
            value={firstname}
            placeholder="First Name"
            onChange={(e) => setFirstname(e.target.value)}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col span={24}>
          <Input
            value={lastname}
            placeholder="Last Name"
            onChange={(e) => setLastname(e.target.value)}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col span={24}>
          <div className="datetime-item">
            <img src="/images/date.png" />
            <DatePicker
              value={dob}
              placeholder="Date of Birth"
              onChange={(e) => setDOB(e)}
              suffixIcon={<DownOutlined />}
            />
          </div>
        </Col>
      </Row>

      <Row className="d-flex mb-4 mt-3">
        <Col span={12} className="pr-2">
          <Button
            onClick={() => setGender("Female")}
            className={`beam-btn w-full${gender === "Female" ? " green-btn cover" : ""
              }`}
          >
            Female
          </Button>
        </Col>
        <Col span={12} className="pl-2">
          <Button
            onClick={() => setGender("Male")}
            className={`beam-btn w-full${gender === "Male" ? " green-btn cover" : ""
              }`}
          >
            Male
          </Button>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <LocationInput
            placeholder="Enter your address"
            value={
              address?.attributes?.value?.place_id
                ? address?.attributes
                : undefined
            }
            onChange={(value) => {
              setAddress(value);
            }}
          />
        </Col>
      </Row>

      <Row className="action-grp mt-4">
        <Col span={8} className="pr-2">
          <Button
            className="beam-btn yellow-btn cover w-full"
            onClick={() => {
              dispatch(
                ENCRYPT_TOKEN({
                  data: {
                    payload: `userId=${localStorage.getItem(
                      "RID"
                    )}&connectionId=${localStorage.getItem(
                      "RID"
                    )}&cudbServiceId=${projects?.userServiceId}&adminId=${projects?.adminUserId
                      }&roleId=${userInfo?.roleId}`,
                    //   JSON.stringify({
                    //     userId: localStorage.getItem("RID"),
                    //     connectionId: `${localStorage.getItem("CID")}`,
                    //     cudbServiceId: projects?.userServiceId,
                    //   }),
                  },
                  callback: (token) => {
                    // window.open(`${process.env.REACT_APP_SHARED_URI}/911?token=${token.encryptedPayload}`, '_blank');

                    popupCenter(
                      `${process.env.REACT_APP_SHARED_URI}/profile?token=${token.encryptedPayload}`,
                      "Profile",
                      window.innerWidth * 0.7,
                      window.innerHeight * 0.9
                    );
                  },
                })
              );
            }}
          >
            Extended
          </Button>
        </Col>

        <Col span={8} className="pr-2">
          <Button
            className="beam-btn green-btn cover w-full"
            onClick={handleOk}
          >
            Save
          </Button>
        </Col>
        <Col span={8}>
          <Button
            className="beam-btn orange-btn bordered w-full"
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </Col>
      </Row>
      {isUploadModalVisible && (
        <UploadFileModal
          onClose={() => setIsUploadModalVisible(false)}
          isBio={true}
        />
      )}
    </Modal>
  );
};

export default EditBioModal;
